import { Dispatch, SetStateAction } from "react";
import EstablishmentUnitForm from "./EstablishmentUnitForm";
import { Alert } from "reactstrap";


const EstablishmentUnitCreate = ({
  nextButtonFunction,
  setIsEstablishmentUnitInit,
  updateInterfaceData
}: EstablishmentUnitCreateProps) => {

  const initialValues: IEstablishmentUnitForm = {
    unitType: "",
    unitID: ""
  }

  const handleSubmit =  (values: IEstablishmentUnitForm) => {
      updateInterfaceData(values);
      setIsEstablishmentUnitInit(true);
      nextButtonFunction();
  };
  
  return (
    <>
    <Alert color="danger">
      The Steps of the wizard are not yet fully implemented
    </Alert>
    <EstablishmentUnitForm 
      type={"create"} 
      initialValues={initialValues} 
      onSubmit={handleSubmit}    
    />
    </>
  )
}

export default EstablishmentUnitCreate;

type EstablishmentUnitCreateProps = {
  nextButtonFunction: () => void;
  setIsEstablishmentUnitInit: Dispatch<SetStateAction<boolean>>;
  updateInterfaceData: (data: Partial<IEstablishmentInterfaceForm>) => void;
}